import { IStaticAccordion } from "../../../../../Contracts/StaticDataAccordion";
import { LegislationSections } from "../../../../Model/Enum/BEE123Enums";

export const WspAtr_Legislations_Mandates : Array<IStaticAccordion> = [
    {
      title: "Legislative Mandates",
      groups: [
        {
          items: [
            {
              title: "Skills Development Act (SDA) 1998 (Act No. 97 of 1998) as amended",
              link:
                "Skills Development Act 97 of 1998.pdf",
              section: LegislationSections.Legislative_Mandate
            },
            {
              title: "Skills Development Levies Act (SDLA), 1999 (Act No. 09 of 1999)",
              link:
                "Skills Development Levies Act 9 of 1999.pdf",
              section: LegislationSections.Legislative_Mandate
            },
            {
              title: "Regulations published in the Goverment Gazette, No.35940, 3 December 2012 regarding Monies Received by a SETA and Related Matters",
              link:
                "DHET 2012 SETA Grant Regulations Gazette 35940.pdf",
              section: LegislationSections.Legislative_Mandate
            },
            {
              title: "The National Qualifications Framework Act (NQF), (Act No. 67 of 2008)",
              link:
                "National Qualifications Framework Act 67 of 2008.pdf",
              section: LegislationSections.Legislative_Mandate
            },
            {
              title: "Employment Equity Act (EE), 1998(Act No. 55, 1998)",
              link:
                "Employment Equity Act 55 of 1998.pdf",
              section: LegislationSections.Legislative_Mandate
            },
            {
              title: "Employment Equity Amendment Act 4 of 2022",
              link:
                "Employment Equity Amendment Act 4 of 2022.pdf",
              section: LegislationSections.Legislative_Mandate
            },
            {
              title: "Employment Equity Amendment Act 47 of 2013",
              link:
                "Employment Equity Amendment Act 47 of 2013.pdf",
              section: LegislationSections.Legislative_Mandate
            },
            {
              title: "National Skills Development (NSDP) 2030",
              link:
                "National Skills Development Plan (NSDP) 2030.pdf",
              section: LegislationSections.Legislative_Mandate
            },
            {
              title: "Skills Development Amendment Act 2003",
              link:
                "Skills Development Amendment Act 2003.pdf",
              section: LegislationSections.Legislative_Mandate
            },
            {
              title: "Skills Development Amendment Act 2008",
              link:
                "Skills Development Amendment Act 2008.pdf",
              section: LegislationSections.Legislative_Mandate
            },
            {
              title: "Skills Development Amendment Act 2011",
              link:
                "Skills Development Amendment Act 2011.pdf",
              section: LegislationSections.Legislative_Mandate
            },
          ],

        },
      ],
    }
  ];
  